'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "httpClient", "onError", "onSuccess", "trimInputValue", "type", "requireProtocol", "requireHttps", "validationMessage", "validateDefaultValue"];
import { Component } from 'react';
import http from 'hub-http/clients/apiClient';
import UIValidatedFormControl from 'ui-addon-form-validation/core/UIValidatedFormControl/UIValidatedFormControl';
import urlMessageDefaults from './urlMessageDefaults';
import { urlValidationTypes } from './urlValidationConstants';
import { jsx as _jsx } from "react/jsx-runtime";
export default class UIValidatedUrlFormControl extends Component {
  render() {
    const _this$props = this.props,
      {
        children,
        httpClient = http,
        onError,
        onSuccess,
        trimInputValue = false,
        type = urlValidationTypes.basic,
        requireProtocol = false,
        requireHttps = false,
        validationMessage = urlMessageDefaults,
        validateDefaultValue = false
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    return /*#__PURE__*/_jsx(UIValidatedFormControl, Object.assign({}, rest, {
      trimInputValue: trimInputValue,
      validator: "url",
      validationMessage: validationMessage,
      validateDefaultValue: validateDefaultValue,
      validationOpts: {
        type,
        httpClient,
        requireProtocol,
        requireHttps
      },
      onSuccess: onSuccess,
      onError: onError,
      children: children
    }));
  }
}

/**
 * @typedef {Object} UIValidatedUrlFormControlProps
 * @property {React.ReactNode} children
 * @property {Object} [validationMessage]
 * @property {boolean} [validateDefaultValue]
 * @property {boolean} [trimInputValue]
 * @property {function} [onError]
 * @property {function} [onSuccess]
 * @property {string} [type] - one of urlValidationTypes keys
 * @property {Object|function} [httpClient]
 * @property {boolean} [requireProtocol]
 * @property {boolean} [requireHttps]
 * @property {string} [value]
 */